import { FC, ReactNode, useEffect, useState } from 'react';

export type ScrollDirections = 'down' | 'up' | null;
export const useScrollDirection = (): ScrollDirections => {
  const [scrollDirection, setScrollDirection] = useState<ScrollDirections>(null);

  useEffect(() => {
    let lastScrollY = window.pageYOffset;

    const updateScrollDirection = () => {
      const scrollY = window.pageYOffset;
      const direction = scrollY > lastScrollY ? 'down' : 'up';
      if (direction !== scrollDirection) {
        setScrollDirection(direction);
      }
      lastScrollY = scrollY > 0 ? scrollY : 0;
    };
    window.addEventListener('scroll', updateScrollDirection); // add event listener
    return () => {
      window.removeEventListener('scroll', updateScrollDirection); // clean up
    };
  }, [scrollDirection]);

  return scrollDirection;
};

export interface HideOnScrollDownProps {
  children: ReactNode;
  enabled?: boolean;
}

export const HideOnScrollDown: FC<HideOnScrollDownProps> = ({ children, enabled = true }) => {
  const scrollDirection = useScrollDirection();
  return (
    <div className={`overflow-hidden`}>
      <div
        className={`transition-all duration-300 ease-in-out ${enabled && scrollDirection === 'down' ? '-translate-y-[100%]' : ''} `}
      >
        {children}
      </div>
    </div>
  );
};
